import { Component, OnInit } from '@angular/core';
import { PrFormConstructor } from '@app/components/pr-form/pr-form.contructor';

import { Subject } from 'rxjs';
import { SubscriptionFacadeService } from '../../services/subscription-facade.service';
import { EaSubscriptionBuilder } from './ea-subscription-form.builder';
import { knowledgeFinancialAssetsOptions } from '../../services/ref';

@Component({
    selector: 'risk-profil-second-part-form',
    templateUrl: './risk-profil-second-part-form.component.html',
    styleUrls: ['./risk-profil-second-part-form.component.scss'],
    standalone: false
})
export class RiskProfilSecondPartFormComponent
  extends EaSubscriptionBuilder
  implements OnInit
{
  subscriptions: any[] = [];

  doneSubject: Subject<void> = new Subject<void>();
  page: number = 1;
  knowledgeFinancialAssetsOptions = knowledgeFinancialAssetsOptions;
  productType: string;

  constructor(
    protected formConstructor: PrFormConstructor,
    private subscriptionFacade: SubscriptionFacadeService,
  ) {
    super(formConstructor);
  }

  ngOnInit() {
    this.productType = this.subscriptionFacade.getPledge()?.productType;
    this.subscriptionFacade.initForm(this, { productType: this.productType });
  }

  onSubmit() {
    this.form.markAsDirty();
    this.subscriptionFacade.submitPledge(this);
  }

  prev() {
    this.subscriptionFacade.previousStep();
  }
}
